import { render, staticRenderFns } from "./InboundTransfersDataTable.template.vue?vue&type=template&id=9ab6fa14&scoped=true&"
var script = {}
import style0 from "./InboundTransfersDataTable.template.vue?vue&type=style&index=0&id=9ab6fa14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab6fa14",
  null
  
)

export default component.exports